import * as z from "zod";

export const NewUserSchema = z.object({
  email: z.string().email("Please enter a valid email address").min(1).max(100),
  firstName: z.string().min(1, "First Name is required").max(64),
  lastName: z.string().min(1, "Last Name is required").max(64),
  roles: z.array(z.string()),
});
